import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-4-col-tiles.scss'

export default register(`section-4-col-tiles`, {
    onLoad() {

    },
    onUnload() {

    }
})
